import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { getUserFullName, constants, mixpanel } from 'common/helpers'
import ValueLink from 'sb-valuelink'
import cx from 'classnames'
import { connect } from 'redaction'
import { FormattedMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './SubscriptionWasCancelledModal.scss'


class SubscriptionWasCancelledModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    userFullName: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.SubscriptionWasCancelled,
  }

  constructor() {
    super()

    this.state = {
      activeRateNum: 0,
    }
  }

  resubscribe = () => {
    actions.models.subscription.resubscribe({
      resubscribeCode: constants.resubscribeTypes.resubnew,
      popup: constants.analyticsEvents.resubscribePopup.postCancel,
    })
      .then(({ premiumProduct }) => {
        if (premiumProduct) {
          actions.models.modals.open(constants.modals.premiumProducts.WelcomeBack, {
            item: premiumProduct,
          })
        }
        else {
          actions.models.modals.open(constants.modals.resubscribe.ResubscribeSuccess)
        }

        this.close()
      }, () => {})
  }

  finish = () => {
    const { activeRateNum } = this.state

    mixpanel.track(constants.analyticsEvents.cancelFlow.resubscribeNps, {
      type: activeRateNum,
    })

    if (activeRateNum) {
      actions.models.subscription.rateResubscribe(activeRateNum)
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, userFullName } = this.props
    const activeRateNumLink = ValueLink.state(this, 'activeRateNum')

    return (
      <Modal
        name={name}
        title={messages.title}
      >
        <FormattedMessage className={s.text} tag="div" {...messages.text} values={{ userName: userFullName }} />
        <Button className={s.button} brand title={messages.resubscribeButton} onClick={this.resubscribe} />
        <FormattedMessage className={s.resubscribeQuestionTitle} tag="div" {...messages.resubscribeQuestion} />
        <div className={s.rate}>
          {
            Array
              .apply(null, { length: 10 })
              .map((undef, index) => ++index)
              .map((num) => {
                const rateNumContainerClassName = cx(s.rateNum, {
                  [s.active]: activeRateNumLink.value === num,
                })

                return (
                  <div
                    key={num}
                    className={rateNumContainerClassName}
                    onClick={() => activeRateNumLink.set(num)}
                  >
                    <div className={s.rateNumTitle}>{num}</div>
                  </div>
                )
              })
          }
        </div>
        <ModalFooter>
          <CommonButton brand finish onClick={this.finish} />
        </ModalFooter>
      </Modal>
    )
  }
}


export default connect({
  userFullName: (state) => getUserFullName(state),
})(SubscriptionWasCancelledModal)
